import { memo, useEffect } from 'react'

import styles from './TrustPilotWidget.module.css'
import { TrustPilotProps } from './TrustPilotWidget.types'

function TrustPilotSection({
  templateId = '54ad5defc6454f065c28af8b',
  height = '240px',
  ...rest
}: TrustPilotProps) {

  useEffect(() => {
    if (window.Trustpilot) {
      window.Trustpilot.Modules.WidgetManagement.initializeOnPageLoad()
    }
  }, [window.Trustpilot])

  return (
    <section {...rest}>
      <script
        type='text/javascript'
        src='//widget.trustpilot.com/bootstrap/v5/tp.widget.bootstrap.min.js'
        async
      ></script>
      <div
        className={`${styles.trustpilotWidget} trustpilot-widget`}
        data-locale='en-US'
        data-template-id={templateId}
        data-businessunit-id='643425faa32b6caee5a4666a'
        data-style-height={height}
        data-style-width='100%'
        data-theme='dark'
        data-stars='4,5'
        data-review-languages='en'
      >
        <a
          href='https://www.trustpilot.com/review/betty.ca'
          target='_blank'
          rel='noopener noreferrer'
        >
          Trustpilot
        </a>
      </div>
    </section>
  )
}

export default memo(TrustPilotSection)
